import React, { useState, useEffect } from 'react';
import ProductDetail from './ProductDetail';
import SystemDetail from './SystemDetail';
import { API_URL } from '../config';
import handleProductClick from '../App.js';

function Technical({ products, category, loading, selectedProduct, onProductSelect, selectedSystem, onSystemSelect,
                        isAuthenticated, onProductClick, onBackToCategory, currency, formatPrice, currencyLoading }) {
  const [systems, setSystems] = useState([]);
  console.log('onBackToCategory', onBackToCategory)

  // Fetch systems for marine category
  useEffect(() => {
    if (category === 'marine') {
      fetch(`${API_URL}/api/systems/by_category/?category=marine`)
        .then(res => res.json())
        .then(data => {
          setSystems(data);
        })
        .catch(err => console.error('Error fetching systems:', err));
    } else {
      setSystems([]);
    }
  }, [category]);

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  const getColorValue = (color) => {
    if (color.includes('linear-gradient')) {
      const match = color.match(/#[0-9A-Fa-f]{6}/);
      return match ? match[0] : '#0288D1';
    }
    return color;
  };

  return (
    <div id="td">
      {/* Product and System buttons - always visible */}
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '4px', 
        marginBottom: '12px' 
      }}>
        {/* System buttons (for marine) */}
        {systems.map(system => {
          const isSelected = selectedSystem?.id === system.id;
          const mainColor = getColorValue(system.color);
          return (
            <button
              key={`system-${system.id}`}
              className="pb"
              onClick={() => onSystemSelect(system)}
              style={{
                borderColor: isSelected ? mainColor : undefined,
                background: isSelected ? `${mainColor}08` : undefined
              }}
            >
              <div style={{ fontSize: '9px', fontWeight: '800', color: '#374151' }}>
                {system.name}
              </div>
              <div style={{ fontSize: '6px', color: '#9CA3AF' }}>
                {system.system_type.replace(' System', '')}
              </div>
            </button>
          );
        })}
        
        {/* Product buttons */}
        {products.map(product => {
          const isSelected = selectedProduct?.id === product.id;
          return (
            <button
              key={`product-${product.id}`}
              className="pb"
              onClick={() => onProductSelect(product)}
              style={{
                borderColor: isSelected ? product.color : undefined,
                background: isSelected ? `${product.color}08` : undefined
              }}
            >
              <div style={{ fontSize: '9px', fontWeight: '800', color: '#374151' }}>
                {product.code}
              </div>
              <div style={{ fontSize: '6px', color: '#9CA3AF' }}>
                {product.api_spec}
              </div>
            </button>
          );
        })}
      </div>

      {/* System detail, Product detail, or placeholder */}
      {selectedSystem ? (
        <SystemDetail system={selectedSystem} />
      ) : selectedProduct ? (
        <ProductDetail
          product={selectedProduct} 
          onClose={() => onProductSelect(null)}
          category={category}
          isAuthenticated={isAuthenticated}
          onProductClick={onProductClick}
          allProducts={products}
          onBackToCategory={onBackToCategory}
          currency={currency}
          formatPrice={formatPrice}
          currencyLoading={currencyLoading}
        />
      ) : (
        <div id="tdp" style={{
          padding: '40px',
          textAlign: 'center',
          background: '#fff',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          fontSize: '13px',
          color: '#9CA3AF'
        }}>
          Select a package above
        </div>
      )}
    </div>
  );
}

export default Technical;
